import { render, staticRenderFns } from "./basic-cards.vue?vue&type=template&id=dbc82b24"
import script from "./basic-cards.vue?vue&type=script&lang=js"
export * from "./basic-cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports